
import _ from 'lodash';
import {HALF_DAY_PACKAGE, HARBOR_CRUISE, TEASER_ID} from "@/constants/package-types.enum";


export function isTimeSelectable(time, blockDates, edited){

    if (blockDates[edited.date]) {
        return (
            _.find(blockDates[edited.date], {'time': time}) !== undefined
            &&
            _.find(blockDates[edited.date], {'id': edited.id,'package_name': edited.beforePackageName,'time': time}) === undefined
        )
            ? false : true
    }
    return true
}

export function checkReservedDate(date, blockDates, edited, unitNamesPackagesPictures, thisUnitPackageNameId){

    if (edited.unit === 0 || (edited.unitObject == null && edited.unit == null)) {
        return false;
    }

    if(
        blockDates[date] &&

        _.find(blockDates[date], {
            'id': edited.id,
            'package_name': edited.packageName,
            'time': edited.time
        })
    ){
        return false;
    }

    let unitId = edited.unitObject !== null ? edited.unitObject.id : edited.unit.id;
    let unitIndex = unitId - 1;

    if (unitNamesPackagesPictures[unitIndex] == undefined) {
        return false;
    }

    let maintenance_from = unitNamesPackagesPictures[unitIndex].maintenance_from;
    let maintenance_to = unitNamesPackagesPictures[unitIndex].maintenance_to;

    if( Date.parse(date) >= Date.parse(maintenance_from) && Date.parse(date) <= (Date.parse(maintenance_to)) ){
        return true;
    }

    let packageId = thisUnitPackageNameId[edited.packageName];

    let packageActiveFrom = null;
    let packageActiveTo = null;
    unitNamesPackagesPictures[unitIndex].packages.map(function(unitPackage){

        if( packageId == unitPackage.id && packageActiveFrom == null && packageActiveTo == null ){
            packageActiveFrom = unitPackage.active_from;
            packageActiveTo = unitPackage.active_to;
        }
    });

    if( packageActiveFrom != null || packageActiveTo != null ){

        if( packageActiveFrom != null && packageActiveTo == null && Date.parse(date) < Date.parse(packageActiveFrom) ){
            return true;
        }

        if( packageActiveTo != null && packageActiveFrom == null && Date.parse(date) > Date.parse(packageActiveTo) ){
            return true;
        }

        if( packageActiveTo != null && packageActiveFrom != null && (Date.parse(date) < Date.parse(packageActiveFrom) || Date.parse(date) > (Date.parse(packageActiveTo))) ){
            return true;
        }
    }

    if ( unitId === TEASER_ID && edited.packageName === HALF_DAY_PACKAGE ) {

        if (
            blockDates[date]
            &&
            (
                ( _.find(blockDates[date], {'package_name': HALF_DAY_PACKAGE }) === undefined && _.find(blockDates[date], {'package_name': HARBOR_CRUISE }) === undefined )
                ||
                ( blockDates[date].length == 2 && _.find(blockDates[date], {'package_name': HALF_DAY_PACKAGE }) !== undefined )  /*blockDates[date].time.length === 2*/
                ||
                blockDates[date].length == 3
            )
        ) {
            return true;
        }
        return false;
    }

    if ( unitId === TEASER_ID && edited.packageName === HARBOR_CRUISE ) {

        if (
            blockDates[date]
            &&
            (
                ( _.find(blockDates[date], {'package_name': HARBOR_CRUISE }) === undefined && !_.find(blockDates[date], {'package_name': HALF_DAY_PACKAGE }) === undefined )

                ||

                blockDates[date].length == 3
            )
        ) {
            return true;
        }

        return false;
    }

    return Object.keys(blockDates).includes(date)
}